function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { mode } from "@chakra-ui/theme-tools";
var register = {
  parts: ["overlay", "content", "header", "body", "footer"],
  sizes: ["xs", "sm", "md", "lg", "xl", "2xl", "3xl", "4xl", "5xl", "6xl", "full"]
};

var baseStyle = props => {
  return {
    overlay: {
      bg: "blackAlpha.600"
    },
    content: _extends({}, props.isFullHeight && {
      height: "100vh"
    }, {
      bg: mode("white", "gray.700")(props),
      color: "inherit",
      boxShadow: mode("lg", "dark-lg")(props)
    }),
    header: {
      paddingX: 6,
      paddingY: 4,
      fontSize: "xl",
      fontWeight: "semibold"
    },
    body: {
      paddingX: 6,
      paddingY: 2,
      flex: 1,
      overflow: "auto"
    },
    footer: {
      paddingX: 6,
      paddingY: 4
    }
  };
};
/**
 * Since the `maxWidth` prop references theme.sizes internally,
 * we can leverage that to size our modals.
 */


var getSize = value => ({
  content: {
    maxWidth: value
  }
});

var sizes = {
  xs: getSize("xs"),
  sm: getSize("md"),
  md: getSize("lg"),
  lg: getSize("2xl"),
  xl: getSize("4xl"),
  full: getSize("100vw")
};
var defaultProps = {
  size: "xs"
};
var modal = {
  register,
  defaultProps,
  baseStyle,
  sizes
};
export default modal;
//# sourceMappingURL=drawer.js.map